import debounce from 'lodash.debounce';

class SiteHeader {
    constructor(el) {
        this.el = el;

        this.isSticky = false;
        this.isTicking = false;
        this.stickyOffset = this.el.offsetHeight;
        this.lastScrollPosition = window.pageYOffset;
        this.scrollDirection = 'undetermined';
        this.updateFn = this._update.bind(this);

        if(this.el) {
            this._init();
            this._onScroll();
            this._onResize();
            this._bindEvents();
        }
    }

    _init() {
        this.sections = [...document.querySelectorAll('[data-color-scheme]')];
        
        if(this.sections.length) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if(!this._shouldUpdate(entry)) return;
                    
                    const target = this._getTargetSection(entry.target);
                    
                    this._updateColors(target);
                });
            }, 
            {
                rootMargin: `${this.el.offsetHeight * -1}px`,
                threshold: 0
            });

            this.sections.forEach((el) => {
                observer.observe(el);
            });
        }
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        this.onResizeFn = debounce(this._onResize.bind(this), 200);

        window.addEventListener('scroll', this.onScrollFn);
        window.addEventListener('resize', this.onResizeFn);
    }

    _updateColors(target) {
        const colorScheme = target.dataset.colorScheme;
        this.el.setAttribute('data-color-scheme', colorScheme);
    }

    _shouldUpdate(entry) {
        if(this.scrollDirection === 'undetermined') {
            return true;
        }

        if(this.scrollDirection === 'down' && !entry.isIntersecting) {
            return true;
        }

        if(this.scrollDirection === 'up' && entry.isIntersecting) {
            return true;
        }

        return false;
    }

    _getTargetSection(target) {
        if(this.scrollDirection === 'undetermined') {
            return this.sections[0];
        }

        if(this.scrollDirection === 'up') {
            return target;
        }
      
        const index = this.sections.findIndex((section) => section == target);
            
        if(index >= this.sections.length - 1) {
            return target;
        } 
        else {
            return this.sections[index + 1];
        }
    }

    _setScrollDirection() {
        if(window.pageYOffset > this.lastScrollPosition) {
            this.scrollDirection = 'down';
        } 
        else if(window.pageYOffset < this.lastScrollPosition) {
            this.scrollDirection = 'up';
        }
    }

    _onScroll() {
        this._setScrollDirection();
        this.lastScrollPosition = window.pageYOffset;

        if(!this.isTicking) {
            this.isTicking = true;

            window.requestAnimationFrame(this.updateFn);
        }
    }

    _onResize() {
        document.documentElement.style.setProperty('--header-height', `${this.el.offsetHeight}px`);
    }

    _update() {
        this.isTicking = false;

        if(!this.isSticky && this.lastScrollPosition >= this.stickyOffset) {
            this.el.classList.add('site-header--sticky');
            this.isSticky = true;
            this._onResize();
        }
        else if(this.isSticky && this.lastScrollPosition < this.stickyOffset) {
            this.el.classList.remove('site-header--sticky');
            this.isSticky = false;
            this._onResize();
        }
    }
}

export default SiteHeader;
